import { StyleMessage, StyleMessageItemWrapper, StyleWrapper } from './style'
import Column from '@components/column'
import Skeleton from '@components/skeleton'

const SupportMessageItemLoader = ({ index }: any) => {
  const isOwner = index % 2 == 0

  return (
    <StyleWrapper isOwner={isOwner}>
      <StyleMessageItemWrapper>
        <StyleMessage isOwner={isOwner}>
          <Skeleton width={200} height={10} radius={4} />
          <Skeleton
            width={150}
            height={10}
            radius={4}
            styleSkeleton="margin-top:5px;"
          />
          <Skeleton
            width={150}
            height={10}
            radius={4}
            styleSkeleton="margin-top:5px;"
          />
          <Column alignItems="flex-end" styleColumn="margin-top:5px">
            <Skeleton width={50} height={10} radius={4} />
          </Column>
        </StyleMessage>
      </StyleMessageItemWrapper>
    </StyleWrapper>
  )
}
export default SupportMessageItemLoader
